export const HOME_WHY_SECTION = {
  label: "WHY HOPE SCIENCE",
  title: "왜 희망과학을 찾을까요?",
  subtitle: "온라인으로 간편하게 수강 가능한 재범방지 교육 프로그램입니다",
  watermark: "Hope Science Counseling Center",
};

export const HOME_WHY_FEATURES = [
  {
    id: "fast",
    number: "01",
    title: "빠른 수강",
    description: "평균 15분 내외 3단계 프로세스",
    icon: "clock",
  },
  {
    id: "expert",
    number: "02",
    title: "전문성 기반",
    description: "변호사 협력 기반 교육 과정",
    icon: "certificate",
  },
  {
    id: "unlimited",
    number: "03",
    title: "무제한 반복수강",
    description: "기간 제한 없이 언제든 재수강 가능",
    icon: "infinity",
  },
];
